import { Link } from "react-router-dom";

export function StatusPill({ s }) {
  const map = {
    pending: "border-yellow-500 text-yellow-500",
    approved: "border-blue-400 text-blue-400",
    rejected: "border-neutral-500 text-neutral-500 line-through",
    paid: "border-[#FF3B30] text-[#FF3B30]",
    cancelled: "border-neutral-600 text-neutral-500",
    completed: "border-green-500 text-green-500",
  };
  return (
    <span className={`inline-block px-2 py-1 border text-xs uppercase tracking-widest ${map[s] || ""}`}>{s}</span>
  );
}

export function CookBookingsTable({ bookings, busy, onPay, onCancel }) {
  if (bookings.length === 0) {
    return (
      <div className="border hairline p-10 text-center">
        <p className="text-neutral-400">No bookings yet.</p>
        <Link data-testid="cook-browse-btn" to="/browse" className="btn-signal inline-block mt-4">Find a kitchen</Link>
      </div>
    );
  }
  return (
    <div className="border hairline">
      <table className="w-full">
        <thead className="border-b hairline">
          <tr className="text-left tick-label">
            <th className="p-4">Kitchen</th>
            <th className="p-4">When</th>
            <th className="p-4">Total</th>
            <th className="p-4">Status</th>
            <th className="p-4"></th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((b) => (
            <tr key={b.id} data-testid={`booking-row-${b.id}`} className="border-b hairline">
              <td className="p-4 font-semibold">{b.kitchen_name}</td>
              <td className="p-4 font-mono text-sm">
                {new Date(b.start_time).toLocaleString()}<br/>
                <span className="text-neutral-500">{b.hours}h</span>
              </td>
              <td className="p-4 font-mono">${b.total.toFixed(2)}</td>
              <td className="p-4"><StatusPill s={b.status} /></td>
              <td className="p-4">
                {b.status === "approved" && b.payment_status !== "paid" && (
                  <button
                    data-testid={`pay-${b.id}`}
                    onClick={() => onPay(b.id)}
                    disabled={busy === b.id}
                    className="btn-signal disabled:opacity-50"
                  >
                    {busy === b.id ? "..." : "Pay now"}
                  </button>
                )}
                {["pending", "approved", "paid"].includes(b.status) && b.status !== "cancelled" && (
                  <button
                    data-testid={`cancel-${b.id}`}
                    onClick={() => onCancel(b.id)}
                    className="btn-outline ml-2 inline-block"
                  >Cancel</button>
                )}
                <Link data-testid={`msg-${b.id}`} to={`/messages/${b.id}`} className="btn-outline ml-2 inline-block">Messages</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
